import { Accordion } from '@cfa/react-core';

interface SubcategoryAccordionProps {
  children?: React.ReactNode;
  'data-testid'?: string;
  id?: number | string;
  name: string;
}

const SubcategoryAccordionItem = ({
  name,
  'data-testid': dataTestId,
  children = null,
  id,
}: SubcategoryAccordionProps) => (
  <Accordion.Item id={`${id}`} data-testid={dataTestId}>
    <Accordion.Trigger>{name}</Accordion.Trigger>
    <Accordion.Panel>
      <div className="my-1">{children}</div>
    </Accordion.Panel>
  </Accordion.Item>
);

export default SubcategoryAccordionItem;
